import { render, staticRenderFns } from "./PhoneNumberLibrary.vue?vue&type=template&id=00545572&scoped=true"
import script from "./PhoneNumberLibrary.vue?vue&type=script&lang=js"
export * from "./PhoneNumberLibrary.vue?vue&type=script&lang=js"
import style0 from "./PhoneNumberLibrary.vue?vue&type=style&index=0&id=00545572&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00545572",
  null
  
)

export default component.exports